import { render, staticRenderFns } from "./MrFooter.vue?vue&type=template&id=f279f5a8&lang=pug"
import script from "./MrFooter.vue?vue&type=script&lang=js"
export * from "./MrFooter.vue?vue&type=script&lang=js"
import style0 from "./MrFooter.vue?vue&type=style&index=0&id=f279f5a8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports